import { useSelector, useDispatch } from 'react-redux';
import { fetchSessionTypes } from "../../../redux/resources/resourcesSlice";
import { useCallback } from "react";
import { RootState } from '../../../redux';
import { AppDispatch } from '../../../redux';



const useFetchSessionTypeResource = () => {

    const dispatch = useDispatch<AppDispatch>();
    const { sessionTypes, isLoading } = useSelector((state: RootState) => state.resources);

    const fetchSessionTypeData = useCallback(async () => {
        await dispatch(fetchSessionTypes());
    }, [dispatch]);

    return { sessionTypes, isLoading, fetchSessionTypeData}
}


export default useFetchSessionTypeResource
